var _path, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAudifonos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3053_168)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3451 3.87207C11.0646 3.87207 4.33789 10.5988 4.33789 18.8793C4.33789 27.1597 11.0646 33.8864 19.3451 33.8864H20.2279V39.1831C28.8084 35.0517 34.3523 26.8242 34.3523 18.8793C34.3523 10.5988 27.6255 3.87207 19.3451 3.87207Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3053_168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3053_168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 27C11.45 27 10.9792 26.8042 10.5875 26.4125C10.1958 26.0208 10 25.55 10 25V18C10 16.7667 10.2375 15.6042 10.7125 14.5125C11.1875 13.4208 11.8333 12.4667 12.65 11.65C13.4667 10.8333 14.4208 10.1875 15.5125 9.7125C16.6042 9.2375 17.7667 9 19 9C20.2333 9 21.3958 9.2375 22.4875 9.7125C23.5792 10.1875 24.5333 10.8333 25.35 11.65C26.1667 12.4667 26.8125 13.4208 27.2875 14.5125C27.7625 15.6042 28 16.7667 28 18V28C28 28.55 27.8042 29.0208 27.4125 29.4125C27.0208 29.8042 26.55 30 26 30H20C19.7167 30 19.4792 29.9042 19.2875 29.7125C19.0958 29.5208 19 29.2833 19 29C19 28.7167 19.0958 28.4792 19.2875 28.2875C19.4792 28.0958 19.7167 28 20 28H26V27H24C23.45 27 22.9792 26.8042 22.5875 26.4125C22.1958 26.0208 22 25.55 22 25V21C22 20.45 22.1958 19.9792 22.5875 19.5875C22.9792 19.1958 23.45 19 24 19H26V18C26 16.0667 25.3167 14.4167 23.95 13.05C22.5833 11.6833 20.9333 11 19 11C17.0667 11 15.4167 11.6833 14.05 13.05C12.6833 14.4167 12 16.0667 12 18V19H14C14.55 19 15.0208 19.1958 15.4125 19.5875C15.8042 19.9792 16 20.45 16 21V25C16 25.55 15.8042 26.0208 15.4125 26.4125C15.0208 26.8042 14.55 27 14 27H12ZM12 25H14V21H12V25ZM24 25H26V21H24V25Z",
    fill: "#0099CC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3053_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.1765,
    height: 38.1765,
    fill: "white",
    transform: "translate(0.255859 0.254883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAudifonos);
export default __webpack_public_path__ + "static/media/ico_audifonos.c5ffdae966f7327f7496aecf00b4291e.svg";
export { ForwardRef as ReactComponent };